export default __webpack_public_path__ + "static/media/juego1_instrucciones.594c756d.png";